import { render, staticRenderFns } from "./projectsIndex.vue?vue&type=template&id=2cd11f00"
import script from "./projectsIndex.vue?vue&type=script&lang=js"
export * from "./projectsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports